module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACHSURBVHgBjVKJDYAgDGyJg+gGjIAbOIJO4AjiJI7gCm7gCmyiR1INEnkuuZTQuysE6BJQBmi34A6OigqAaEY5wQFsm1wqygaacF8VUk3cayKhllRNCahAvEhqUvwxAEwVeA3MbFE60FUZxORAb1qrDD/TjipDMK3HcgqPyc+3QDN5aXlE6yfezDo3B/CHU14AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/audio/btn_player_backward.png
// module id = w3Ln
// module chunks = 1